<template>
    <div class="search-detail-view">
        <!-- 導航欄 -->
        <van-nav-bar fixed title="搜尋詳情" left-arrow @click-left="onBack" />
        <searchItemView v-for='(goods,index) in searchDataList' :key='index' :goods='goods'></searchItemView>
    </div>
</template>

<script>
    import { NavBar } from "vant";
    import searchItemView from '../searchItemView/searchItemView.vue';

    export default {
        name: 'searchDetailView',
        props: ['searchDataList'],
        components: {
            [NavBar.name]: NavBar,
            searchItemView
        },
        methods: {
            onBack: function () {
                this.$emit('onBack')
            }
        },
    }
</script>

<style  lang='scss'>
    .search-detail-view {
        position: fixed;
        width: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        background-color: #f2f2f2;
        padding-top: 45px;
        margin-bottom: 50px;
        overflow: auto;
    }
</style>